import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
    title: {
        fontSize: '12px',
        color: theme.palette.grey["600"],
        fontWeight: 800
    },
    subInfo: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '4px',
    },
    subLabel: {
        fontWeight: 500,
        marginRight: '6px',
        fontSize: '13px',
        color: '#555',
    },
    subValue: {
        fontSize: '13px',
        color: '#000',
    },
}));

export {useStyles}